import { DateTime } from "luxon";
import { ContactSummary } from "./contact-summary";
import { MemberRecordStatus, MemberType, ThreeLevelScale } from "./enums";
import { TopicOfInterest } from "./topic-of-interest";
import { Language } from "./language";

export class MembershipRecord {
    public id: number | null = null;
    public trialMember: boolean = false;
    public memberType: MemberType | null = null;
    public topics: TopicOfInterest[] = [];
    public contractStartDate: string | null = null;
    public contractEndDate: string | null = null;
    public language: Language | null = null;
    public engagementLevel: ThreeLevelScale | null = null;
    public notes: string = '';
    public primaryContact: ContactSummary | null = null;
    public invoicingContact: ContactSummary | null = null;
    public contractContact: ContactSummary | null = null;

    lastModifiedBy?: string | null;
    lastModifiedOn?: string | null;

    constructor(init?: Partial<MembershipRecord>) {
        Object.assign(this, init);
    }

    getStatus(): MemberRecordStatus {
        const now = DateTime.now();
        if (this.contractStartDate && this.contractEndDate) {
            const startDate = DateTime.fromISO(this.contractStartDate);
            const endDate = DateTime.fromISO(this.contractEndDate);

            if (now < startDate) {
                return MemberRecordStatus.FUTURE;
            } else if (now > endDate) {
                return MemberRecordStatus.PAST;
            } else {
                return MemberRecordStatus.ACTIVE;
            }
        } else if (this.contractStartDate && !this.contractEndDate) {
            const startDate = DateTime.fromISO(this.contractStartDate);

            if (now < startDate) {
                return MemberRecordStatus.FUTURE;
            } else {
                return MemberRecordStatus.ACTIVE;
            }
        }
        return MemberRecordStatus.INVALID;
    }

    isValid(): boolean {
        return this.getStatus() != MemberRecordStatus.INVALID;
    }

    isActive(): boolean {
        return this.getStatus() == MemberRecordStatus.ACTIVE;
    }

    isFuture(): boolean {
        return this.getStatus() == MemberRecordStatus.FUTURE;
    }

    isPast(): boolean {
        return this.getStatus() == MemberRecordStatus.PAST;
    }

    get engagementLevelDisplay(): string {
        switch (this.engagementLevel) {
            case ThreeLevelScale.LOW:
                return 'Low';
            case ThreeLevelScale.MEDIUM:
                return 'Medium';
            case ThreeLevelScale.HIGH:
                return 'High';
            default:
                return 'N/A';
        }
    }

    get membershipTypeDisplay(): string {
        switch (this.trialMember) {
            case true:
                return 'Trial';
            case false:
                return 'Effective';
            default:
                return 'Effective';
        }
    }

    get memberTypeDisplay(): string {
        switch (this.memberType) {
            case MemberType.FULL:
                return 'Full';
            case MemberType.ASSOCIATE:
                return 'Associate';
            default:
                return 'N/A';
        }
    }

    get memberTopicsDisplay(): string {
        if (this.topics)
            return this.topics.map(t => t.name).sort().join(', ');
        else
            return '';
    }

    get contractPeriodDisplay(): string {
        const startDate = (this.contractStartDate ? DateTime.fromISO(this.contractStartDate).toFormat('dd/MM/yyyy') : null);
        const endDate = (this.contractEndDate ? DateTime.fromISO(this.contractEndDate).toFormat('dd/MM/yyyy') : null);
        return `${startDate ?? 'N/A'} - ${endDate ?? ''}`;
    }
}
